export default "__VITE_ASSET__BJ4WI6lI__"